export class Recommend {
    constructor() { }
    /**
     * Loads the recommended checkboxes into the DOM.
     * @returns {void}
     */
    loadRecommendedCheckboxes() {
        const checkRecommend = document.querySelectorAll('.check-recommender-pauta');
        checkRecommend.forEach((input) => {
            const inputValue = input.getAttribute('value') || '';
            const recommendedId = input.getAttribute('recommended') || '';
            const fair = input.getAttribute('fair') || '';
            const checkbox = this.createCheckbox(inputValue, recommendedId, fair);
            input.appendChild(checkbox);
        });
    }
    /**
     * Creates a checkbox with the necessary properties.
     * @param {string} value - The value of the original input element.
     * @param {string} recommendedId - The recommended ID for the checkbox.
     * @param {string} fair - The fair attribute for the checkbox.
     * @returns {HTMLInputElement} - The created checkbox element.
     */
    createCheckbox(value, recommendedId, fair) {
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.setAttribute('recommended_id', recommendedId);
        checkbox.setAttribute('fair', fair);
        checkbox.classList.add('input-select', 'check-recommender');
        checkbox.value = value;
        return checkbox;
    }
    /**
     * Verifies and updates the validity status of the container based on selected checkboxes.
     * @returns {void}
     */
    checkContainerStatus() {
        const checkboxes = this.getCheckboxes();
        let uncheckedCount = this.countUncheckedCheckboxes(checkboxes);
        const contentItems = document.getElementById('content-items');
        if (contentItems) {
            if (uncheckedCount === 4) {
                contentItems.classList.add('invalid');
                contentItems.classList.remove('valid');
            }
            else {
                contentItems.classList.add('valid');
                contentItems.classList.remove('invalid');
            }
        }
    }
    /**
     * Retrieves all the recommended checkboxes from the DOM.
     * @returns {HTMLInputElement[]} - List of recommended checkboxes.
     */
    getCheckboxes() {
        return Array.from(document.getElementsByClassName('check-recommender'));
    }
    /**
     * Counts how many checkboxes are unchecked.
     * @param {HTMLInputElement[]} checkboxes - List of checkboxes.
     * @returns {number} - Number of unchecked checkboxes.
     */
    countUncheckedCheckboxes(checkboxes) {
        return checkboxes.reduce((counter, checkbox) => counter + (!checkbox.checked ? 1 : 0), 0);
    }
    /**
     * Initializes the necessary event listeners for handling checkbox changes.
     * @returns {void}
     */
    initializeEvents() {
        const checkboxes = this.getCheckboxes();
        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', () => this.checkContainerStatus());
        });
    }
    /**
     * Loads the complete functionality for the recommended checkboxes.
     * @returns {void}
     */
    loadRecommend() {
        this.loadRecommendedCheckboxes(); // Load recommended checkboxes into the DOM
        this.initializeEvents(); // Initialize events for the checkboxes
    }
}
// Create an instance of the Recommend class for usage
export const recommend = new Recommend();
